import { render, staticRenderFns } from "./suitch-stone.vue?vue&type=template&id=2dc25dbe&"
import script from "./suitch-stone.vue?vue&type=script&lang=js&"
export * from "./suitch-stone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports